export enum TicketTypeRouteName {
    Index = 'ticket-types.index',
    Create = 'ticket-types.create',
    Edit = 'ticket-types.edit',
}

export default {
    path: 'ticket-types',
    name: TicketTypeRouteName.Index,
    component: () => import('./pages/index.vue'),
    meta: {
        label: 'Ticket Types',
        icon: 'fal fa-text fa-fw',
        location: 'sidebar',
        permission: 'manage-tickets',
        auth: true,
        group: 'main',
    },
    children: [
        {
            path: 'create',
            name: TicketTypeRouteName.Create,
            component: () => import('./pages/index.vue'),
            meta: {
                auth: true,
                label: 'Create Ticket Type',
                permission: 'manage-tickets',
                group: 'main',
            },
        },
        {
            path: ':ticketTypeUuid/edit',
            name: TicketTypeRouteName.Edit,
            component: () => import('./pages/index.vue'),
            meta: {
                auth: true,
                label: 'Edit Ticket Type',
                permission: 'manage-tickets',
                group: 'main',
            },
        },
    ],
}
